import { ROLE_DISPLAY_LABELS, roleLabelForDisplay } from 'utils/entityTerminology';

/** @deprecated Prefer importing ROLE_DISPLAY_LABELS from utils/entityTerminology */
export const USER_ROLE_LABELS = ROLE_DISPLAY_LABELS;

export const getRoleLabel = (roleCode) => roleLabelForDisplay(roleCode);
